// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"f6ddd1b2","249":"7429a916"}[chunkId] + ".chunk.css";
};